import * as React from 'react';

import {FormField} from 'shells/form/form-field';

import {TextfieldWithSave} from './textfield-with-save';

type Props = {
    website: string;
    setWebsite: (value: string) => void;
    isWebsiteSaving: boolean;
    errorMessage: string | null | undefined;
    setErrorMessage: (arg1?: string | null | undefined) => void;
    isSaveDisabled: boolean;
    // In an onboarding context the save is not in the field
    onSaveWebsite?: () => void;
};

export function WebsiteField(props: Props) {
    const {
        website,
        setWebsite,
        isWebsiteSaving,
        errorMessage,
        setErrorMessage,
        onSaveWebsite,
        isSaveDisabled,
    } = props;

    return (
        <FormField key={website} innerId='website' errorMessage={errorMessage} noMargin={true}>
            <TextfieldWithSave
                name='website'
                value={website}
                onChange={(value: string) => {
                    setErrorMessage(null);
                    setWebsite(value);
                }}
                autoFocus={true}
                isSaving={isWebsiteSaving}
                onSave={onSaveWebsite}
                // @ts-expect-error
                disabled={isSaveDisabled}
                errorSaving={Boolean(errorMessage)}
            />
        </FormField>
    );
}
